// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"a049cd88","124":"6ecfba90","196":"4b797526","225":"96adebee","251":"416c3323","326":"9dcba351","578":"d58b173c","604":"1994dcc4","679":"6c95094e","692":"455c3715","721":"b8bd0f48","794":"45d0b368","884":"303d5412","891":"d06d8fa9","966":"ddd37a54"}[chunkId] + ".chunk.js";
};